import styled, { css } from "styled-components"

import { Link as _Link, PlainLink as _PlainLink } from "components/text"
import { Box, InlineList, InlineListItem } from "components/box"

const linkCSS = css`
  display: block;
  padding: ${props => props.theme.space[6]};
  border-bottom: 1px solid ${props => props.theme.colors.silver};

  color: ${props => props.theme.colors.evergreen};
  font-family: ${props => props.theme.fonts.paragraph};
  font-size: 14px;
  text-decoration: none;
`

const PlainLink = styled(_PlainLink)`
  ${linkCSS}
`

const Link = styled(_Link)`
  ${linkCSS}
`

const Container = styled(Box)`
  position: absolute;
  top: 100%;
  right: 0;

  width: 100%;
  max-height: 90vh;
  overflow: auto;
  text-align: center;
  padding-top: ${props => props.theme.space[3]};
  padding-bottom: ${props => props.theme.space[3]};
  background-color: ${props => props.theme.colors.white};
  border-top: 1px solid ${props => props.theme.colors.evergreen};
  border-bottom: 1px solid ${props => props.theme.colors.evergreen};
  z-index: ${props => props.theme.layers.menu};

  @media screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    border: 1px solid ${props => props.theme.colors.evergreen};
    width: 260px;
  }

  @media screen and (min-width: 1600px) {
    /* this is needed because the max-width of the header is fixed (1440px) and we want to fix the dropdown under the avatar menu */
    right: calc((100vw - 1440px) / 2 - 260px / 4);
  }
`

const List = styled(InlineList)`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0 ${props => props.theme.space[5]} ${props => props.theme.space[5]};
`

export const DropdownMenu = {
  PlainLink,
  Link,
  Container,
  List,
  Item: InlineListItem
}
